<template>
  <v-row v-if="dynamicFormWithAnswerData === null">
    <v-row dense align="center">
      <v-col cols="6" v-for="index in 6" :key="index">
        <v-row dense align="center">
          <v-col>
            <v-skeleton-loader type="heading" transition="fade-transition" />
          </v-col>
        </v-row>

        <v-row dense align="center">
          <v-col>
            <v-skeleton-loader type="card-heading" transition="fade-transition" />
          </v-col>
          <v-col>
            <v-skeleton-loader type="card-heading" transition="fade-transition" />
          </v-col>
          <v-col>
            <v-skeleton-loader type="card-heading" transition="fade-transition" />
          </v-col>
        </v-row>

        <v-row dense align="center">
          <v-col>
            <v-skeleton-loader type="card-heading" transition="fade-transition" />
          </v-col>
          <v-col>
            <v-skeleton-loader type="card-heading" transition="fade-transition" />
          </v-col>
          <v-col>
            <v-skeleton-loader type="card-heading" transition="fade-transition" />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-row>

  <v-row v-else>
    <DynamicFormLink
      v-for="link in links"
      :key="link.id"
      :answerableId="answerableId"
      :answerableType="answerableType"
      :link="link"
      :readOnly="disabled"
      :refreshForm="pullAnswerData"
    >
      <template v-slot:useButton="{ shard }">
        <slot name="useButton" v-bind:shard="shard"></slot>
      </template>
    </DynamicFormLink>
  </v-row>
</template>

<script>
  import GET_DYNAMIC_FORM from "@/graphql/dynamic_form/dynamic_form_full.gql";

  import DynamicFormLink from "@/components/dynamic_form/link.vue";
  import { DynamicFormService } from "@/services/DynamicFormService";

  export default {
    name: "DynamicFormCore",
    components: {
      DynamicFormLink,
    },
    props: {
      answerableId: {
        type: String,
        required: true,
      },
      answerableType: {
        type: String,
        required: true,
      },
      dynamicFormType: String,
      dynamicFormModel: {
        type: Object,
        default: () => {
          return {};
        },
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    model: {
      prop: "dynamicFormModel",
      event: "change",
    },
    data() {
      return {
        dynamicForm: null,
        dynamicFormWithAnswerData: null,
      };
    },
    apollo: {
      dynamicForm: {
        query: GET_DYNAMIC_FORM,
        variables() {
          return {
            dynamicFormType: this.dynamicFormType,
            answerableId: this.answerableId,
            answerableType: this.answerableType,
          };
        },
        fetchPolicy: "cache-and-network",
        result() {
          this.pullAnswerData();
        },
        update: (data) => data.dynamicFormFull,
      },
    },
    computed: {
      links() {
        return this.dynamicFormWithAnswerData?.links || [];
      },
    },
    methods: {
      async pullAnswerData() {
        if(!this.dynamicForm) return;

        this.dynamicFormWithAnswerData = await new DynamicFormService().fetchAndMergeAnswerData({
          dynamicForm: this.dynamicForm,
          answerableId: this.answerableId,
          answerableType: this.answerableType,
        });
      },
    },
  };
</script>

<style lang="scss" scoped></style>
